import { render, staticRenderFns } from "./EventOrganizerSelect.vue?vue&type=template&id=0c8c144e"
import script from "./EventOrganizerSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventOrganizerSelect.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports